import List from "@/components/list";
import router from "@/router";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  //调查用户
  function invesUserList(exam) {
    router.push({
      path: "/investigation/members",
      query: { id: exam.uuid }
    });
  }
  const Deal = ({ props: { vo } }) => {
    const exam = vo.row;
    const dealConf = [
      ["icon-invest-user-list", "调查用户", () => invesUserList(exam), ""]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "问卷名称",
      prop: "questionnaireName",
      minWidth: "160"
    },
    {
      label: "发布状态",
      prop: "publishStatusName",
      minWidth: "120"
    },
    {
      label: "调查状态",
      prop: "investigationStatusName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      minWidth: "160",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
